module.exports = __webpack_public_path__ + "img/8416d2219b8c6dcf70c40f028e10e1fd.d84b6976.png";